import { fMonthDayTimeYear } from "../../utils/formatTime";

export function addUserToDict(dict, date, actionBy, actionType, user) {
  const formattedDate = fMonthDayTimeYear(date);
  if(!dict[formattedDate]) dict[formattedDate] = {};
  if(!dict[formattedDate][actionBy]) dict[formattedDate][actionBy] = {};
  if(!dict[formattedDate][actionBy][actionType]) dict[formattedDate][actionBy][actionType] = [];
  dict[formattedDate][actionBy][actionType].push({ ...user, actionDate: new Date(date), actionType });
}

export function joinWithAnd(arr) {
  if (arr.length === 0) return '';
  if (arr.length === 1) return arr[0];
  if (arr.length === 2) return `${arr[0]} and ${arr[1]}`;
  return `${arr.slice(0, -1).join(', ')} and ${arr[arr.length - 1]}`;
}

export function getMessagesAndUserActionsSorted(messages, users, type) {
  const messagesList = messages?.map((message) => ({ ...message, actionDate: new Date(message.sentOn || message.dateAdded), type: 'message' }));
  const userActionsDict = {}
  users?.forEach((user) => {
    if(user.dateAdded) {
      const { addedBy } = user;
      const date = new Date(user.dateAdded);
      addUserToDict(userActionsDict, date, addedBy, 'addUser', user);
    }
    if(user.deleteFlag && user.dateDeleted) {
      const { deletedBy } = user;
      const date = new Date(user.dateDeleted);
      addUserToDict(userActionsDict, date, deletedBy, 'removeUser', user);
    }
  });
  const userActionsList = [];
  Object.entries(userActionsDict).forEach(([date, byDict]) => {
    Object.entries(byDict).forEach(([actionBy, typeDict]) => {
      Object.entries(typeDict).forEach(([actionType, usersArr]) => {
        // Combine all items in the array into one string (e.g., names)
        const len = usersArr.length;
        const combinedNames = joinWithAnd(usersArr.map(u => u.userName || u.fullName || u.userEmail));
        const action = len > 1 ? actionType === 'addUser' ? 'were added to' : 'were removed from' : actionType === 'addUser' ? 'was added to' : 'was removed from';
        const by = actionBy !== 'null' ? ` by ${actionBy}` : '';
        const message = `${combinedNames} ${action} the ${type} on ${date}${by}`;
        userActionsList.push({
          actionDate: usersArr[0].actionDate,
          type: actionType,
          message
        });
      });
    });
  });
  const combinedList = [...messagesList, ...userActionsList];
  return [...combinedList].sort((a, b) => a.actionDate - b.actionDate);
}
